<ng-container>
  <app-data-table
    [columns]="cols"
    [data]="fundData"
    [url]="'/master/fund/'"
    [isCardView]="false"
    (viewEventRow)="viewSystem($event)"
    [isView]="'/master/fund' | hasPermission : 'View'"
    [isDeletable]="'/master/fund' | hasPermission : 'Delete'"
    [showAddButton]="'/master/fund' | hasPermission : 'Add'"
    [showActions]="canEditSetup"
    [isEditable]="'/master/fund' | hasPermission : 'Edit'"
    (onPresentView)="getSystem()"
    [title]="title"
    (onAdd)="addEquipment()"
    (editEventRow)="updateFund($event)"
    (deleteEventRow)="showDeletePopup($event)"
    (onLazyLoadData)="getSystem($event)"
    [totalRecords]="totalRecords"
  >
  </app-data-table>
</ng-container>

<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="addDialogConfig"
  [initialData]="{}"
  [viewMode]="false"
  (onSubmit)="onSubmitAdd($event)"
  (onCancel)="onCancelAdd()"
  (onClose)="onCloseAdd()"
></app-reusable-dialog>

<app-reusable-dialog
  [(visible)]="isUpdatedialog"
  [config]="updateDialogConfig"
  [initialData]="selectedFundData"
  [viewMode]="viewMode"
  (onSubmit)="onSubmitUpdate($event)"
  (onCancel)="onCancelUpdate()"
  (onClose)="onCloseUpdate()"
></app-reusable-dialog>

<p-dialog
  header="Delete Fund"
  [modal]="true"
  [(visible)]="showDeleteDialog"
  [style]="{ width: '30rem' }"
  [maximizable]="true"
>
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete fund ?</span>
    <p-button
      label="Delete"
      icon="pi pi-trash"
      severity="danger"
      [outlined]="true"
      (click)="deleteequipment()"
      class="mt-2"
    >
    </p-button>
  </div>
</p-dialog>
